import { useFlags } from "launchdarkly-react-client-sdk"
import useCarrotPlanEmployeeSettings from "#/components/carrot-plans/hooks/useCarrotPlanEmployeeSettings"

/**
 * Hook to determine if a member is in a sensitive scenario.
 *
 * Checks both the LaunchDarkly flag 'member-check-in-sensitive-scenario' and
 * a hardcoded fallback value.
 *
 * This hook can be reused across components to determine when to show
 * sensitive scenario-specific UI elements like JourneyDisplay.
 */
export function useIsMemberInSensitiveState(): boolean {
  const { memberCheckInSensitiveScenario } = useFlags()
  const { isSensitiveState } = useCarrotPlanEmployeeSettings()

  return memberCheckInSensitiveScenario && isSensitiveState
}
